












import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

// Views
import Selector from '@/components/common/Selector.vue'

const FILE_TYPES = ['csv', 'xlsx']
const SEND_METHODS = ['download', 'mail']

@Component({
  components: {
    Selector
  }
})
export default class Exporter extends Vue {
  typeSelected = null
  methodSelected = null

  @Prop({ type: Boolean, default: false }) all: boolean
  @Prop({ type: Number, default: 0 }) count: number

  get typeItems() {
    return FILE_TYPES.map((type) =>  ({ label: type.toUpperCase(), value: type }))
  }

  get sendItems() {
    return SEND_METHODS.map((type) =>  ({ label: this.$t(`exporter.method.${type}`), value: type }))
  }

  get currentType() {
    return this.typeSelected.label.toUpperCase()
  }

  get currentMethod() {
    return this.methodSelected.label || this.sendItems[0]
  }

  updateExportType(object) {
    this.typeSelected = object
  }

  updateExportMethod(object) {
    this.methodSelected = object
  }

  created() {
    this.typeSelected = { label: 'CSV', value: 'csv' }
    this.methodSelected = { label: this.$t('exporter.method.download'), value: 'download' }
  }

  triggerExport() {
    this.$emit('trigger', {
      type: this.typeSelected.value,
      method: this.methodSelected.value
    })
  }
}
